const BASE_URL = "https://api.yalladad.com/api";
// const BASE_URL = "http://localhost:5001/api";

// export const URL = "http://localhost:5001";
 export const URL = "https://api.yalladad.com";

export default BASE_URL;
